import { z } from 'zod';
// ============================================
// Announcements — Duyuru Modülü
// ============================================
//
// Yonetici duyuru olusturur, hedef kitleyi secer (tum ogrenciler / bir egitimi
// alanlar / secilen ogrenciler). Her hedef ogrenci icin in-app feed kaydi olur.
export const AnnouncementAudienceSchema = z.enum(['all', 'course', 'students']);
export const AnnouncementSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    body: z.string(),
    audience: AnnouncementAudienceSchema,
    courseId: z.string().uuid().nullable(),
    createdById: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
    // hydrated (admin liste)
    recipientCount: z.number().int().nonnegative().optional(),
    readCount: z.number().int().nonnegative().optional(),
    courseName: z.string().nullable().optional(),
});
export const CreateAnnouncementSchema = z
    .object({
    title: z.string().min(1).max(200),
    body: z.string().min(1).max(10_000),
    audience: AnnouncementAudienceSchema,
    courseId: z.string().uuid().optional(),
    studentUserIds: z.array(z.string().uuid()).max(2000).optional(),
})
    .superRefine((v, ctx) => {
    if (v.audience === 'course' && !v.courseId) {
        ctx.addIssue({
            code: 'custom',
            path: ['courseId'],
            message: 'courseId required for course audience',
        });
    }
    if (v.audience === 'students' && (!v.studentUserIds || v.studentUserIds.length === 0)) {
        ctx.addIssue({
            code: 'custom',
            path: ['studentUserIds'],
            message: 'studentUserIds required for students audience',
        });
    }
});
export const CreateAnnouncementResultSchema = z.object({
    announcement: AnnouncementSchema,
    recipients: z.number().int().nonnegative(),
});
// Öğrenci/veli "Duyurular" feed öğesi.
export const StudentAnnouncementSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    body: z.string(),
    createdAt: z.string().datetime(),
    readAt: z.string().datetime().nullable(),
    // veli birden çok çocuk için görebilir
    studentName: z.string().nullable().optional(),
});
//# sourceMappingURL=announcement.js.map